import VideoPlayerButton from './video-player-button'
class VideoPlayerButtonEmbedded extends VideoPlayerButton {
  /**
   * inits the video selector
   */
  init () {
    this.selectors.video = 'iframe'
    this.loadYoutubeIframeAPI()
  }

  /**
   * method called in connectedCallback method
   */
  buttonMountedCallback () {
    document.addEventListener('iframeAPIReady', this.initializeYoutubeVideo.bind(this))
  }

  /**
   * get video duration
   * @returns {Number}
   */
  getVideoDuration () {
    return this.videoEmbedded.getDuration()
  }

  /**
   * get the button state
   * -1 (unstarted)
   * 0 (ended)
   * 1 (playing)
   * 2 (paused)
   * 3 (buffering)
   * 5 (video cued)
   * @returns {String}
   */
  getVideoState () {
    const currentState = this.videoEmbedded.getPlayerState()
    let status
    if (currentState === 5) status = 'videoCued'
    if (currentState === 2) status = 'paused'
    if (currentState === 1) status = 'playing'
    if (currentState === 0) status = 'ended'
    return status
  }

  /**
   * Method to Play the video
   */
  playVideo () {
    this.videoEmbedded.playVideo()
  }

  /**
   * Method to pause video
   */
  pauseVideo () {
    this.videoEmbedded.pauseVideo()
  }

  /**
   * despite being loaded in the head tags, this is not a blocking script
   * as it's only called when an embedded video is on the page
   * onYouTubeIframeAPIReady() is a callback function fired by the youtube api
   * @see {@link https://developers.google.com/youtube/iframe_api_reference}
   */
  loadYoutubeIframeAPI () {
    if (!document.getElementById('youtube_iframe_api')) {
      window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady
      const tag = document.createElement('script')
      tag.id = 'youtube_iframe_api'
      tag.src = 'https://www.youtube.com/iframe_api'
      const firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    }
  }

  /**
   * State listener for the youtube video
   * @param {EventListenerObject} event
   */
  stateListener (event) {
    // eslint-disable-next-line no-undef
    if (event.data === YT.PlayerState.PLAYING || event.data === YT.PlayerState.PAUSED) {
      this.handleVideoPlayPause()
      // eslint-disable-next-line no-undef
    } else if (event.data === YT.PlayerState.ENDED) {
      this.handleVideoEnd()
    }
  }

  /**
   * Plays autoplay video on ready and init event listeners
   * @param {EventListenerObject} event
   */
  playOnReadyAutoplay (event) {
    const autoplayYoutubePlayer = this.video.dataset.autoplay
    if (autoplayYoutubePlayer) {
      event.target.playVideo()
    }
    // Initialize button state
    this.updateButtonState()
    // Add event listeners
    this.addEventListeners()
  }

  /**
   * initilize youtube video object on youtube api ready
   */
  initializeYoutubeVideo () {
    // eslint-disable-next-line no-undef
    this.videoEmbedded = new YT.Player(this.video, {
      events: {
        onReady: this.playOnReadyAutoplay.bind(this),
        onStateChange: this.stateListener.bind(this)
      }
    })
  }

  /**
   * call back function fired by the youtube api
   */
  onYouTubeIframeAPIReady () {
    const apiReadyEvent = new CustomEvent('iframeAPIReady')
    document.dispatchEvent(apiReadyEvent)
  }
}

// Define the custom button element
customElements.define('video-player-button-embedded', VideoPlayerButtonEmbedded, { extends: 'button' })
